// Format a number as FCFA with thin-space thousand separators
// e.g. 9500 -> "9 500 FCFA"
export function formatFCFA(value) {
  const n = Math.round(Number(value) || 0);
  return n.toLocaleString('fr-FR').replace(/\u00A0/g, ' ') + ' FCFA';
}
